/* eslint-disable */
import { call, CreateReplyBody } from 'services/api-service'

/**
 * Create a reply to an answer
 *
 * @method
 * @name ApiService#createReply
 * @param {string} contextToken -
 * @param {string} qualifier - confirmed or unconfirmed
 * @param {string} sku -
 * @param {string} originSiteKey -
 * @param {CreateReplyBody} body -
 */
function createReply(
  parameters: {
    'context-token'?: string
    qualifier: string
    sku: string
    originSiteKey?: string
  },
  body: CreateReplyBody
): Promise<{
  stagedReplyToken?: string
}> {
  return call<{
    stagedReplyToken?: string
  }>(
    'POST',
    '/{siteKey}/reply/inline/{qualifier}',
    parameters,
    ['qualifier', 'sku'],
    ['sku', 'originSiteKey'],
    ['context-token'],
    body
  )
}

export default { createReply }
